/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/catalog/:id'>.
 * /r/-хвосты (фильтры/пагинация, §3.2) ловит catalog/$id/r/$.tsx.
 */
import { createFileRoute } from '@tanstack/react-router';
import { catalogNotFoundLoader } from '@routes/Catalog/catalogNotFoundLoader';
import CacheDataRoute from '../../../CacheDataRoute';
import Catalog from '@routes/Catalog/component';

export const Route = createFileRoute('/catalog/$id/')({
  // Честный 404 несуществующей рубрики/группы (CONTENT_NOT_FOUND)
  loader: catalogNotFoundLoader,
  component: () => <CacheDataRoute component={Catalog} path='/catalog/:id' />
});
